import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { forwardRef } from 'react';
import { cn } from '../../shared/cn';
export type LinkProps = React.ComponentPropsWithoutRef<'a'> & {
  href: string;
};
export const Link = forwardRef(function Link(t0, ref) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-contentPrimary", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <a {...props} ref={ref} className={t1} />;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});